import { openDialog, WebDialog } from "web-dialog";
import { html, render } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { prepareDialogForWrapper } from "../atoms/dialog-wrapper";
import { AuthProviderKind } from "shared";

export async function openUserAuth({
	text,
	headline,
	kinds
}: { text?: string; headline?: string; kinds?: AuthProviderKind[] } = {}): Promise<boolean | undefined> {
	import("../molecules/user-auth");
	return await openDialog<WebDialog, boolean>({
		initialize: () => {
			const $d = new WebDialog<boolean>();
			$d.style.setProperty("--dialog-max-width", "400px");
			prepareDialogForWrapper($d);
			return $d;
		},
		center: true,
		$content: ($dialog) =>
			render(
				html`
					<bs-user-auth
						@cancel="${() => $dialog.close(false)}"
						@done="${(e: CustomEvent) => $dialog.close(true)}"
						.headline="${ifDefined(headline)}"
						.text="${ifDefined(text)}"
						.kinds="${ifDefined(kinds)}"
					></bs-user-auth>
				`,
				$dialog
			)
	}).resolver;
}
